module.exports = __webpack_public_path__ + "img/guangzhoubowuguan.5f60a7ba.png";